export default __webpack_public_path__ + "static/media/BrainBreak cards20.2039421e.png";